import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import BaseToggle from 'components/Toggle';

type ContainerProps = {
  isError: boolean;
  isDisabled: boolean;
};

type ElementProps = {
  isDisabled: boolean;
};

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  background-color: ${({ isDisabled }) =>
    `${isDisabled ? `rgba(${ColorPalette.RGB.Black}, 0.02)` : ColorPalette.HEX.White}`};
  border: ${({ isError }) => `solid 1px ${isError ? ColorPalette.HEX.RedRYB : ColorPalette.HEX.BrightGray}`};
  border-radius: 12px;
  padding: 16px 16px 16px 24px;
  height: fit-content;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.h1<ElementProps>`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  letter-spacing: -0.2px;
  color: ${({ isDisabled }) => `${isDisabled ? ColorPalette.HEX.PhilippineSilver : ColorPalette.HEX.PineTree}`};
  margin: 0 0 8px 0;
`;

export const Message = styled.span<ElementProps>`
  font-size: 12px;
  line-height: 1.5;
  color: ${({ isDisabled }) => `${isDisabled ? ColorPalette.HEX.PhilippineSilver : ColorPalette.HEX.DimGray}`};
`;

export const Toggle = styled(BaseToggle)`
  margin-right: -8px;
`;

export const Children = styled.div`
  margin-top: 32px;
`;

export const ErrorMessage = styled.span`
  font-size: 12px;
  color: ${ColorPalette.HEX.RedRYB};
  margin-top: -12px;
`;
